import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { DropdownThreeDotsIcon } from "../../dropdown/src";
import { __ } from "../../i18n/src";
import { FONT_BRIGHTNESS } from "../../theme/src";
import { StyledTitle } from './components/Title';
import { PER_CONTENT_TYPE_COMPONENT } from './constants';
const ThreeDotActions = ({ actions }) => (_jsx(Box, { onClick: (e) => e.stopPropagation(), position: "absolute", right: 4, top: 4, children: _jsx(DropdownThreeDotsIcon, { items: actions, title: __('More actions') }) }));
export const ContentRecommendationItem = ({ actions, item, onItemClick, }) => {
    const TypeContentComponent = PER_CONTENT_TYPE_COMPONENT[item.contentType];
    const handleItemClick = useCallback(() => {
        onItemClick(item);
    }, [item, onItemClick]);
    const handleKeyDown = useCallback((evt) => {
        if (evt.key === 'Enter') {
            evt.preventDefault();
            onItemClick(item);
        }
    }, [item, onItemClick]);
    return (_jsx(ContentRecommendationItemWrapper, { "aria-label": item.title, "data-testid": "content-recommendation-item", onClick: handleItemClick, onKeyDown: handleKeyDown, role: "link", tabIndex: 0, children: _jsx(TypeContentComponent, Object.assign({}, item, { threeDotActions: actions.length > 0 ? _jsx(ThreeDotActions, { actions: actions }) : null })) }));
};
const ContentRecommendationItemWrapper = styled(Box).attrs({
    p: { _: 0, m: 4 },
    minHeight: { _: '163px', m: '145px' },
}) `
  border: 1px solid
    ${({ theme }) => {
    if (theme.themeVariables.fontBrightness === FONT_BRIGHTNESS.LIGHT) {
        return theme.colors.snow;
    }
    return theme.colors.horizon;
}};
  border-radius: ${({ theme }) => `${theme.themeVariables.globalBorderRadius}px`};
  cursor: pointer;
  overflow: hidden;
  position: relative;
  width: 100%;

  &:hover,
  &:focus {
    /* Target any StyledTitle component using the component */
    ${StyledTitle} {
      text-decoration: underline;
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
//# sourceMappingURL=ContentRecommendationItem.js.map